import store from '@/store'
export default {
    inserted(el, binding, vnode) {
        const {value} = binding;
        const perms = store.getters && store.getters.permissions;
        const roles = store.getters && store.getters.roles;
        if(roles.includes("admin")){
            return true;
        }
        if (value && value instanceof Array && value.length > 0) {
            const permissions = value;

            const hasPermission = perms.some(role => {
                return permissions.includes(role)
            });

            if (!hasPermission) {
                el.parentNode && el.parentNode.removeChild(el)
            }
        } else {
            throw new Error(`need roles! Like v-can="['admin','editor']"`)
        }
    }
}
